export default __webpack_public_path__ + "static/media/eApprove.19343dc3.svg";